export default __webpack_public_path__ + "static/18-29ed6652648ee5030a72758d6db514bf.png";